import gql from 'graphql-tag';

export const fragments = {
  customer: gql`
    fragment CustomerDetails on Customer {
      id
      identifier
      lastName
      firstName
      phone
      email
      address
      city
      stateOfResidence
      gender
      maritalStatus
      dateOfBirth
      createdAt
    }
  `,
  investmentBreakdown: gql`
    fragment InvestmentBreakdownDetails on CustomerInvestmentBreakdown {
      totalInvestedPrincipal
      totalROI
      count
      totalActivePrincipal
      totalActiveROI
      activeCount
    }
  `,
  investment: gql`
    fragment InvestmentDetails on Investment {
      id
      identifier
      principal
      accumulatedROI
      totalROI
      tenure
      type {
        id
        name
      }
      status {
        id
        name
      }
      package {
        id
        name
      }
      investmentDate
      maturityDate
    }
  `,
  nextOfKin: gql`
    fragment NextOfKinDetails on NextOfKin {
      id
      firstName
      lastName
      phone
      email
      address
      city
      stateOfResidence
      gender
    }
  `,
};

export const CREATE_CUSTOMER = gql`
  mutation CreateCustomer($data: CustomerCreateInput) {
    createCustomer(data: $data) {
      id
    }
  }
`;

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomer($id: ID!, $data: CustomerUpdateInput) {
    updateCustomer(id: $id, data: $data) {
      ...CustomerDetails
      investmentBreakdown {
        ...InvestmentBreakdownDetails
      }
    }
  }
  ${fragments.customer}
  ${fragments.investmentBreakdown}
`;

export const AUTHENTICATE_CUSTOMER = gql`
  mutation AuthenticateCustomer($email: String!, $password: String!) {
    authenticateCustomerWithPassword(email: $email, password: $password) {
      token
      item {
        id
        firstName
        lastName
      }
    }
  }
`;

export const UNAUTHENTICATE_CUSTOMER = gql`
  mutation UnauthenticateCustomer {
    unauthenticateCustomer {
      success
    }
  }
`;

export const VIEWER_QUERY = gql`
  query ViewerQuery {
    viewer: authenticatedCustomer {
      ...CustomerDetails
      investmentBreakdown {
        ...InvestmentBreakdownDetails
      }
    }
  }
  ${fragments.customer}
  ${fragments.investmentBreakdown}
`;

export const VIEWER_INVESTMENTS_QUERY = gql`
  query investmentsQuery {
    viewer: authenticatedCustomer {
      id
      investments(orderBy: "createdAt_DESC") {
        ...InvestmentDetails
      }
      investmentBreakdown {
        ...InvestmentBreakdownDetails
      }
    }
  }
  ${fragments.investment}
  ${fragments.investmentBreakdown}
`;

export const NEXT_OF_KIN_QUERY = gql`
  query NextOfKinQuery {
    viewer: authenticatedCustomer {
      id
      nextOfKin {
        ...NextOfKinDetails
      }
    }
  }
  ${fragments.nextOfKin}
`;

export const UPDATE_NEXT_OF_KIN = gql`
  mutation UpdateNextOfKin($nextOfKinId: ID!, $data: NextOfKinUpdateInput!) {
    updateNextOfKin(id: $nextOfKinId, data: $data) {
      ...NextOfKinDetails
    }
  }
  ${fragments.nextOfKin}
`;

export const CREATE_NEXT_OF_KIN = gql`
  mutation($customerId: ID!, $data: NextOfKinCreateInput!) {
    updateCustomer(id: $customerId, data: { nextOfKin: { create: $data } }) {
      id
      nextOfKin {
        ...NextOfKinDetails
      }
    }
  }
  ${fragments.nextOfKin}
`;

export const CHANGE_PASSWORD_WITH_TOKEN = gql`
  mutation ChangePasswordWithToken($token: String!, $password: String!) {
    changePasswordWithToken(token: $token, password: $password)
  }
`;

export const CUSTOMER_REQUEST_INVESTMENT = gql`
  mutation CustomerRequestNewInvestment {
    customerRequestNewInvestment {
      success
      message
    }
  }
`;
